/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//コンパクトブログ、アコーディオン
$('.c-accordion .c-open').each(function() {
  var $question = $(this);
  $question.on('click', function() {
    $(this).next('.panel').slideToggle();
    $(this).toggleClass('c-active');
  });
});

window.onload = function() {
    var elements = document.getElementsByClassName('d-1');

    Array.from(elements).forEach(function(element) {
        if (element.offsetHeight > 368) {
            element.style.maxHeight = "369px";
            element.style.overscrollBehaviorY = "contain";
            element.style.overflowY = "scroll";
        }
    });
}

$(document).on("keydown", "form.Cart input", function(event) {
    if (event.which === 13) {
        event.preventDefault();
        return false;
    }
});

/**
 * ヘッダー内の言語切り替えボタンのテキストを変更す
 */
$(document).ready(function() {
    changeLangText();
  });

  $(window).on('resize',function(){
    changeLangText();
  });

  function changeLangText(){

    if(window.innerWidth > 640){
      $('[class*="ly-custom"] [data-language-code="en"]').text('English');
      $('[class*="ly-custom"] [data-language-code="zh-CN"]').text('中文');
    }else{
      $('[class*="ly-custom"] [data-language-code="en"]').text('EN');
      $('[class*="ly-custom"] [data-language-code="zh-CN"]').text('中文');
    }
  }

/**
 * Header Logo Image Set
 *
 */

window.addEventListener('DOMContentLoaded',()=>{
  let logoImgUrl = sessionStorage.getItem('logoImgUrl');
  let logoLinkURL = sessionStorage.getItem('logoLink');
  const logoLink = document.querySelectorAll('.Header__logoImage a');
  const logoImg = document.querySelectorAll('.Header__LogoLink img');

  if(!logoImgUrl){
    const image = header_image[Math.floor(Math.random() * header_image.length)];
    sessionStorage.setItem('logoImgUrl',image.image_url);
    sessionStorage.setItem('logoLink',image.link);
    logoImgUrl = image.image_url;
    logoLinkURL = image.link;
  }

  if(window.location.href.indexOf('/zh') != -1){
    if(logoLinkURL.indexOf('/zh') == -1){
      logoLinkURL = `/zh${logoLinkURL}`;
    }
  }else{
    logoLinkURL = logoLinkURL.replace('/zh','');
  }

  logoLink.forEach((link)=>{
    if(logoLinkURL != ''){
      link.href = logoLinkURL;
    }
  })
  logoImg.forEach((img)=>{
    img.src = logoImgUrl;
  })
});

/**
 * 商品の注意書き追加
 *
 */
window.addEventListener('DOMContentLoaded',async ()=>{
  const productNotes = document.querySelectorAll('.productNote, .productNoteTop, .productNoteBottom');

  productNotes.forEach((notes)=>{

    notes.style.display = 'none';

    const target = notes.querySelector('.product-note') && notes.querySelector('.product-note').getAttribute('data-target') != null ? '.'  + notes.querySelector('.product-note').getAttribute('data-target') : '.product-note-show';

    const textarea = notes.querySelectorAll('.product-note-text');
    textarea.forEach((text)=>{

      document.querySelectorAll(target).forEach((show)=>{
        const insert_text = document.createElement('div');
        insert_text.style.marginBottom = '15px';
        insert_text.style.marginTop = '15px';
        insert_text.innerHTML = text.innerHTML;
        show.appendChild(insert_text);
      })
    })
  })
});

/**
 * data-action="only-in-stock" の商品のみ表示
 *
*/

window.addEventListener('DOMContentLoaded',async ()=>{

  const url = new URL(location.href);
  const referrer = document.referrer;

  if(document.querySelector('[aria-controls="search-sort-popover"]') != null){

    document.querySelector('[aria-controls="search-sort-popover"]').addEventListener('click',(e)=>{

      const target = document.getElementById( e.target.getAttribute('aria-controls'));

      if(target.getAttribute('aria-hidden') == 'true'){
        target.setAttribute('aria-hidden','false');
        const rect = e.target.getBoundingClientRect();
        target.style.top = `${rect.top + 75}px`;
        document.querySelector('.PageOverlay').classList.add('is-visible');
      }else{
        target.setAttribute('aria-hidden','true');
        document.querySelector('.PageOverlay').classList.remove('is-visible');
        setTimeout(()=>{
          target.style.top = `auto`;
        },500)
      }

    });

    document.querySelectorAll('#search-sort-popover .Popover__Value').forEach((item)=>{
      item.addEventListener('click',(e)=>{
        const text = e.target.innerText;

        closeSortPopover();

      })
    })

    document.querySelector('#search-sort-popover .Popover__Close').addEventListener('click',(e)=>{
      closeSortPopover();
    })

    document.querySelector('.PageOverlay').addEventListener('click',(e)=>{
      closeSortPopover();
    });

    function closeSortPopover(){
      document.querySelector('.PageOverlay').classList.remove('is-visible');
      document.querySelector('#search-sort-popover').setAttribute('aria-hidden','true');
    }
  }


});
